import React from 'react';
import { MapPin, ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';

const ContactInfo = () => {
  const handleDirections = () => {
    window.open('https://www.google.com/maps/dir/?api=1&destination=Rådhusgata%209%2C%200151%20Oslo%2C%20Norway', '_blank');
  };

  return (
    <div className="space-y-8">
      {/* Company Info */}
      <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg">
        <h3 className="text-2xl font-bold text-gray-900 mb-6">Upscale Growth AS</h3>
        <div className="space-y-4">
          <div className="flex items-start space-x-3">
            <MapPin className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
            <div>
              <p className="text-gray-700 font-medium">Our Office</p>
              <p className="text-gray-600">Rådhusgata 9</p>
              <p className="text-gray-600">0151, Oslo, Norway</p>
            </div>
          </div>
        </div>
        <Button
          onClick={handleDirections}
          className="w-full mt-6 bg-blue-600 hover:bg-blue-700 text-white group"
        >
          Get Directions
          <ExternalLink className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
        </Button>
      </div>

      {/* Map Embed */}
      <div className="rounded-2xl overflow-hidden shadow-xl">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2000.0!2d10.7387413!3d59.9127300!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46416e61f267f039%3A0x7e92605fd3231e9a!2sR%C3%A5dhusgata%209%2C%200151%20Oslo%2C%20Norway!5e0!3m2!1sen!2s!4v1234567890"
          width="100%"
          height="300"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Upscale Office Location"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactInfo;